var _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinkLW({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;opacity:0;}.b{fill:#ffffff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 16,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,9.487a1,1,0,0,1-1-1L-1,0A1,1,0,0,1,0-1,1,1,0,0,1,1,0L1,8.487A1,1,0,0,1,0,9.487Z",
    transform: "translate(5 12.003) rotate(-135)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.487,1h0L0,1A1,1,0,0,1-1,0,1,1,0,0,1,0-1L8.488-1a1,1,0,0,1,0,2Z",
    transform: "translate(11 18) rotate(-135)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkLW);
export default __webpack_public_path__ + "static/media/icon_link_l_w.3c6a17ee7199f1d9494e2c2e25b9e0ae.svg";
export { ForwardRef as ReactComponent };